import {createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { REACT_APP_API_URL } from "../env";

export const cancellationPolicyApi = createApi({
    reducerPath: "cancellationPolicyApi",
    baseQuery: fetchBaseQuery({ baseUrl: `${REACT_APP_API_URL}/api` }),
    endpoints: (builder) => ({
        fetchCancellationPolicy: builder.query({
            query: (bookingId) => ({
                url: `hotel/cancel/${bookingId}`,
                method: "GET",
            }),
        }),
    }),
})
export const { useFetchCancellationPolicyQuery } = cancellationPolicyApi;